import Service from '@/untils/service';

const apiService: Function = () => Service;
export default apiService;
